import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { useLocalePreference, LOCALE_PATHS } from "~/lib/use-locale-preference";

// Redirects a locale-agnostic entry (bare "/") to the path matching the remembered locale
// preference. Locale-prefixed URLs (e.g. /fr-CA) are left alone — the URL, not the cookie,
// is authoritative once you're already on one (see LocaleDialog's selectedLanguageId).
export function LocalizationEntryRedirect() {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [locale] = useLocalePreference();

    useEffect(() => {
        if (pathname !== "/") return;

        const targetPath = LOCALE_PATHS[locale];
        if (targetPath !== "/") {
            navigate(targetPath, { replace: true });
        }
    }, [pathname, locale, navigate]);

    return null;
}
